var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_setup.getClass},[_c('a-icon',{style:(_vm.$attrs.iconStyle),attrs:{"icon":"ion:chevron-forward"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }